module.exports = __webpack_public_path__ + "media/home2-left.9a02f05c.mp4";